// Перенос src_ui/web/src/lib/types.ts (js-версия — только рантайм-часть).
export const defaultAppearance = (gender) => ({
  mom: 21,
  dad: 0,
  faceMix: 0.5,
  skinMix: 0.5,
  features: new Array(20).fill(0),
  hair: gender === 'm' ? 3 : 4,
  hairColor: 0,
  hairHighlight: 0,
  eyeColor: 0,
  outfit: 0,
});
